<template>
  <BaseLayoutItemTable>
    <template #list-items>
      <!-- Card 1 -->
      <div
        role="status"
        class="flex items-center justify-between gap-x-6 min-w-[296px] h-[96px] animate-pulse rounded-lg border border-secondary-500 shadow-sm dark:border-gray-700 overflow-hidden whitespace-nowrap">
        <div
          class="shrink-0 w-[96px] h-[96px] rounded-sm bg-secondary-500 dark:bg-gray-700 flex items-center justify-center m-0">
          <svg
            class="h-12 w-12 text-gray-300 dark:text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 640 512">
            <path
              d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
          </svg>
        </div>
        <div
          class="flex-1 flex justify-between items-center space-x-4 overflow-hidden px-4">
          <div class="shrink-0 w-16">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-28 hidden md:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-24 hidden lg:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-28 hidden lg:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div
            class="shrink-0 h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12 hidden sm:block"></div>
        </div>
        <span class="sr-only">{{
          $t("main.loaderCardGridSkeleton.loading")
        }}</span>
      </div>
      <!-- Card 2 -->
      <div
        role="status"
        class="flex items-center justify-between gap-x-6 min-w-[296px] h-[96px] animate-pulse rounded-lg border border-secondary-500 shadow-sm dark:border-gray-700 overflow-hidden whitespace-nowrap">
        <div
          class="shrink-0 w-[96px] h-[96px] rounded-sm bg-secondary-500 dark:bg-gray-700 flex items-center justify-center m-0">
          <svg
            class="h-12 w-12 text-gray-300 dark:text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 640 512">
            <path
              d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
          </svg>
        </div>
        <div
          class="flex-1 flex justify-between items-center space-x-4 overflow-hidden px-4">
          <div class="shrink-0 w-16">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-28 hidden md:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-24 hidden lg:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-28 hidden lg:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div
            class="shrink-0 h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12 hidden sm:block"></div>
        </div>
        <span class="sr-only">{{
          $t("main.loaderCardGridSkeleton.loading")
        }}</span>
      </div>
      <!-- Card 3 -->
      <div
        role="status"
        class="flex items-center justify-between gap-x-6 min-w-[296px] h-[96px] animate-pulse rounded-lg border border-secondary-500 shadow-sm dark:border-gray-700 overflow-hidden whitespace-nowrap">
        <div
          class="shrink-0 w-[96px] h-[96px] rounded-sm bg-secondary-500 dark:bg-gray-700 flex items-center justify-center m-0">
          <svg
            class="h-12 w-12 text-gray-300 dark:text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 640 512">
            <path
              d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
          </svg>
        </div>
        <div
          class="flex-1 flex justify-between items-center space-x-4 overflow-hidden px-4">
          <div class="shrink-0 w-16">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-28 hidden md:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-24 hidden lg:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-28 hidden lg:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div
            class="shrink-0 h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12 hidden sm:block"></div>
        </div>
        <span class="sr-only">{{
          $t("main.loaderCardGridSkeleton.loading")
        }}</span>
      </div>
      <!-- Card 4 -->
      <div
        role="status"
        class="flex items-center justify-between gap-x-6 min-w-[296px] h-[96px] animate-pulse rounded-lg border border-secondary-500 shadow-sm dark:border-gray-700 overflow-hidden whitespace-nowrap">
        <div
          class="shrink-0 w-[96px] h-[96px] rounded-sm bg-secondary-500 dark:bg-gray-700 flex items-center justify-center m-0">
          <svg
            class="h-12 w-12 text-gray-300 dark:text-gray-600"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 640 512">
            <path
              d="M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" />
          </svg>
        </div>
        <div
          class="flex-1 flex justify-between items-center space-x-4 overflow-hidden px-4">
          <div class="shrink-0 w-16">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-28 hidden md:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-24 hidden lg:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div class="shrink-0 w-28 hidden lg:block">
            <div
              class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-16 mb-2.5"></div>
            <div
              class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-28"></div>
          </div>
          <div
            class="shrink-0 h-2.5 bg-gray-300 rounded-full dark:bg-gray-700 w-12 hidden sm:block"></div>
        </div>
        <span class="sr-only">{{
          $t("main.loaderCardGridSkeleton.loading")
        }}</span>
      </div>
    </template>
  </BaseLayoutItemTable>
</template>
